import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { Box, ControlLabelCheckBox, FormField, RadioGroup, Typography } from "@maysoft/common-component-react";

import Strings from "constants/strings";

import Constants from "constants/index";
import { Mode } from "constants/enum";
import { ICodename, IDataDetailAnalysis, IErrorAnalysis } from "commons/interfaces";



export const CardExpertEvaluation = ({
    mode,
    dataOptions,
    dataAnalysis,
    errorAnalysis,
    handleChangeValue,
}: {
    mode: Mode,
    errorAnalysis: IErrorAnalysis;
    dataAnalysis: IDataDetailAnalysis;
    handleChangeValue: (key: string, value: any) => void;
    dataOptions: {
        common: ICodename[];
        levelReport: ICodename[];
    };
}) => {

    return (
        <Card sx={{ padding: 3 }}>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        {Strings.ANALYSIS.EXPERT_EVALUATION}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormField
                        multiline
                        minRows={2}
                        mode={mode}
                        variant={"outlined"}
                        maxLength={Constants.CHAR_MAX_LENGTH.REPORT}
                        label={Strings.ANALYSIS.DETECTION_RESULT + ` (${Strings.formatString(Strings.MESSAGE.CHAR_MAX_LENGTH, Constants.CHAR_MAX_LENGTH.REPORT)})`}
                        defaultValue={dataAnalysis?.detectionResult}
                        errorMessage={errorAnalysis?.detectionResult}
                        placeholder={Strings.ANALYSIS.ENTERT_DETECTION_RESULT}
                        onBlur={(value) => {
                            handleChangeValue("detectionResult", value);
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Box sx={{ gap: 1, display: "flex", flexWrap: "wrap", alignItems: "center" }}>
                        <Typography variant="button" sx={{ fontSize: "0.785rem", lineHeight: 1.5 }} color="secondary">
                            {Strings.ANALYSIS.HAS_SUGGESTED_SOLUTION}:
                        </Typography>
                        <RadioGroup
                            isRow
                            label={""}
                            disabled={mode === Mode.View}
                            dataMulti={dataOptions.common}
                            value={`${dataAnalysis?.hasSuggestedSolution}`}
                            onChangeValue={(value) => {
                                handleChangeValue("hasSuggestedSolution", value);
                            }}
                        />
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Box sx={{ gap: 1, display: "flex", flexWrap: "wrap", alignItems: "center" }}>
                        <Typography variant="button" sx={{ fontSize: "0.785rem", lineHeight: 1.5 }} color="secondary">
                            {Strings.ANALYSIS.FIT_WITH_RECOMMEND_RULE}:
                        </Typography>
                        <RadioGroup
                            isRow
                            label={""}
                            disabled={mode === Mode.View}
                            dataMulti={dataOptions.common}
                            value={`${dataAnalysis?.fitWithRecommendRule}`}
                            onChangeValue={(value) => {
                                handleChangeValue("fitWithRecommendRule", value);
                            }}
                        />
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormField
                        multiline
                        minRows={2}
                        mode={mode}
                        variant={"outlined"}
                        maxLength={Constants.CHAR_MAX_LENGTH.REPORT}
                        label={Strings.ANALYSIS.DETAIL_RECOMMEN_DATION + ` (${Strings.formatString(Strings.MESSAGE.CHAR_MAX_LENGTH, Constants.CHAR_MAX_LENGTH.REPORT)})`}
                        defaultValue={dataAnalysis?.detailRecommendation}
                        errorMessage={errorAnalysis?.detailRecommendation}
                        placeholder={Strings.ANALYSIS.ENTER_DETAIL_RECOMMEN_DATION}
                        onBlur={(value) => {
                            handleChangeValue("detailRecommendation", value);
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <ControlLabelCheckBox
                        isRow
                        isMulti
                        mode={mode}
                        disabled={mode === Mode.View}
                        dataMulti={dataOptions.levelReport}
                        label={Strings.ANALYSIS.LEVEL_REPORT}
                        value={[...dataAnalysis?.levelReport || []]}
                        onChangeValue={(value) => {
                            handleChangeValue("levelReport", value);
                        }}
                    />
                </Grid>
            </Grid>
        </Card>
    );
};

export default CardExpertEvaluation;
